import callApi, { ENDPOINTS } from 'utils/api/callApi'
import { IFile } from 'apps/marketplace/pages/presource-carriers/types'

export interface ICarrierLanePreferenceCsvResponse {
  updated: boolean
}

/**
 * Endpoint for uploading a CSV file
 * @method POST
 * @param bulkTemplate IFile
 * @returns ICarrierLanePreferenceCsvResponse
 *
 */
const uploadCarrierLanePreferenceCsv = (
  bulkTemplate: IFile
): Promise<ICarrierLanePreferenceCsvResponse> =>
  callApi({
    endpoint: ENDPOINTS.carrierLanePreferences,
    group: 'bulk_update',
    method: 'POST',
    body: { bulkTemplate },
  })

export default uploadCarrierLanePreferenceCsv
